import { api } from '../utils/apiThunks'

export function sendData (data) {
	return api.post('users', { body: data })
			.then(response => {
				return response.json()
			})
}
